module.exports = __webpack_public_path__ + "static/media/studio3-1.71bf4874.png";